import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { SalesSummary } from "src/app/shared/models/focusDataModels/SalesSummary";

@Component({
	selector: "app-log-view-sales-summary",
	templateUrl: "./log-view-sales-summary.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class LogViewSalesSummaryComponent implements OnInit {
	@Input() createdDate: string;
	@Input() salesSummary: SalesSummary;

	moment: any = moment;

	constructor() {}

	ngOnInit(): void {}
}
